import i18n from "./../i18n"

/* 회원 로그인 */
export const login = (state, payload) => {
  state.lafia_user.is_logined = true
  state.lafia_user.user_id = payload.user_id
  state.lafia_user.name = payload.name
  state.lafia_user.phone = payload.phone
  state.lafia_user.email = payload.email
  state.lafia_user.profile_image = payload.profile_image
  state.lafia_user.type = payload.type
  state.lafia_user.status = payload.status
  state.lafia_user.created = payload.created
  // SNS 프로필 이미지 저장 (없으면 빈 문자열로 초기화하여 이전 계정 이미지가 남지 않도록 함)
  state.lafia_user.sns_profile_image = payload.sns_profile_image || ""
  // JWT 정보 추가
  if (payload.id !== undefined) {
    state.lafia_user.id = payload.id
  }
  if (payload.userType !== undefined) {
    state.lafia_user.userType = payload.userType
  }
}

// 회원 로그아웃
export const logout = (state) => {
  state.lafia_user.is_logined = false
  state.lafia_user.user_id = ""
  state.lafia_user.name = ""
  state.lafia_user.phone = ""
  state.lafia_user.email = ""
  state.lafia_user.profile_image = ""
  state.lafia_user.sns_profile_image = ""
  state.lafia_user.type = ""
  state.lafia_user.status = ""
  state.lafia_user.created = ""
  state.lafia_user.id = undefined
  state.lafia_user.userType = undefined
}

// 사용자 프로필 수정하기
export const update_profile_image = (state, payload) => {
  state.lafia_user.profile_image = payload
}

// 관리자 로그인
export const admin_login = (state, payload) => {
  state.lafia_user.is_logined = true

  const user_id = payload.user_id || ""
  state.lafia_user.user_id = user_id
  state.lafia_user.name = payload.name || user_id
  state.lafia_user.phone = payload.phone || state.lafia_user.phone
  state.lafia_user.email = payload.email || state.lafia_user.email
  state.lafia_user.profile_image = payload.profile_image || state.lafia_user.profile_image
  state.lafia_user.type = payload.type || payload.provider_type || state.lafia_user.type
  state.lafia_user.status = payload.status || state.lafia_user.status
  state.lafia_user.created = payload.created || state.lafia_user.created
  if (payload.id !== undefined) {
    state.lafia_user.id = payload.id
  }

  const normalizedType = (payload.type || "").toString()
  const derivedUserType = payload.userType || (normalizedType.includes("관리자") ? "admin" : normalizedType ? "staff" : "admin")

  state.lafia_user.userType = derivedUserType
}

// 관리자 로그아웃
export const admin_logout = (state) => {
  logout(state)
}

export const ADD_TEMP_SNS_USER = (state, payload) => {
  state.temp_sns_user = payload
}

export const DELETE_TEMP_SNS_USER = (state) => {
  state.temp_sns_user = {}
}

export const ADD_PROMOTION_CODE = (state, payload) => {
  state.promotionCode = payload
}

export const DELETE_PROMOTION_CODE = (state) => {
  state.promotionCode = undefined
}

export const SET_LANG = (state, payload) => {
  const supportLang = ["ko", "en", "jp"]
  state.lang = supportLang.includes(payload) ? payload : "ko"
  i18n.locale = state.lang
}

export const SET_HOME_TAB = (state, payload) => {
  state.home_selected_tab = payload
}

export const SET_APP_RELOAD_TIME = (state, payload) => {
  state.app_reload_time = payload
}

export const SET_DEFAULT_PRICE = (state, payload) => {
  state.default_price = payload
}

export const SET_DEFAULT_PACKAGE_PRICE = (state, payload) => {
  state.default_package_price = payload
}

export const SET_CONCEPTS = (state, payload) => {
  state.concepts = payload
}

export const SET_OPERATION_TIME = (state, payload) => {
  state.operation_time = payload
}

// ==================== JWT 인증 Mutations ====================

export const SET_ACCESS_TOKEN = (state, token) => {
  state.accessToken = token
}

// JWT 사용자 정보를 lafia_user에 업데이트
export const UPDATE_JWT_USER_INFO = (state, user) => {
  console.log("UPDATE_JWT_USER_INFO", user)
  if (user) {
    if (user.user_id !== undefined) state.lafia_user.user_id = user.user_id
    if (user.name) state.lafia_user.name = user.name
    if (user.email) state.lafia_user.email = user.email
    if (user.phone) state.lafia_user.phone = user.phone
    if (user.profile_image) state.lafia_user.profile_image = user.profile_image
    if (user.provider_type) state.lafia_user.type = user.provider_type === "email" ? "EMAIL" : "SNS"
    if (user.id !== undefined) state.lafia_user.id = user.id
    if (user.userType) state.lafia_user.userType = user.userType
    state.lafia_user.is_logined = true
  }
}

export const SET_IS_REFRESHING = (state, isRefreshing) => {
  state.isRefreshing = isRefreshing
}

export const SET_REFRESH_PROMISE = (state, promise) => {
  state.refreshPromise = promise
}

export const CLEAR_JWT_AUTH = (state) => {
  state.accessToken = null
  state.isRefreshing = false
  state.refreshPromise = null
  // logout mutation도 호출해서 lafia_user 초기화
  state.lafia_user.is_logined = false
  state.lafia_user.user_id = ""
  state.lafia_user.name = ""
  state.lafia_user.phone = ""
  state.lafia_user.email = ""
  state.lafia_user.profile_image = ""
  state.lafia_user.sns_profile_image = ""
  state.lafia_user.type = ""
  state.lafia_user.status = ""
  state.lafia_user.created = ""
  state.lafia_user.id = undefined
  state.lafia_user.userType = undefined
}
